import PropTypes from 'prop-types';

import { Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';

const ignoredProps = ['isActive'];

const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => !ignoredProps.includes(prop),
})(({ theme, isActive }) => ({
  height: '5rem',
  borderRadius: 0,
  justifyContent: 'flex-start',
  borderTop: `.1rem solid ${theme.palette.grey[300]}`,
  '&:last-child': {
    borderBottom: `.1rem solid ${theme.palette.grey[300]}`,
  },
  ...(isActive && {
    fontWeight: theme.typography.fontWeightBold,
    backgroundColor: theme.palette.grey[200],
  }),
}));

const StyledList = styled(Box)(({ theme }) => ({
  overflowX: 'hidden',
  paddingRight: 0,
  width: '30%',
  marginBottom: '2rem',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

const BuildingsSettingsListComponent = ({
  maxHeight,
  buildings,
  selectedBuildingId,
  onBuildingClick,
}) => (
  <StyledList style={maxHeight ? { maxHeight } : {}}>
    {buildings?.map(({ id: buildingId, name: buildingName }) => {
      const isActive = Number(buildingId) === Number(selectedBuildingId);
      return (
        <StyledButton
          key={buildingId}
          onClick={onBuildingClick}
          id={buildingId}
          isActive={isActive}
          fullWidth
        >
          {buildingName}
        </StyledButton>
      );
    })}
  </StyledList>
);

BuildingsSettingsListComponent.defaultProps = {
  maxHeight: null,
  selectedBuildingId: null,
};

BuildingsSettingsListComponent.propTypes = {
  buildings: PropTypes.instanceOf(Array).isRequired,
  onBuildingClick: PropTypes.func.isRequired,
  maxHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selectedBuildingId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default BuildingsSettingsListComponent;
